if (!customElements.get('atelier-registration')) {
customElements.define('atelier-registration', class extends HTMLElement {
connectedCallback() {
  this.form = this.closest('form');
  this.section = document.getElementById('MainProduct-' + this.dataset.section);
  this.picker = this.section.querySelector('variant-selects');
  this.button = this.form.querySelector('[name="add"]');
  this.form.removeAttribute('novalidate');
  this.inventory = JSON.parse(this.querySelector('[data-atelier-inventory]').textContent);
  this.variants = JSON.parse(this.picker.querySelector('script[type="application/json"]').textContent);
  this.addEventListener('input', () => this.sync());
  this.addEventListener('change', () => this.sync());
  this.picker.addEventListener('change', () => this.sync());
  this.form.addEventListener('submit', e => {
    this.sync();
    if (!this.valid() || !this.current()?.available) {
      e.preventDefault(); e.stopImmediatePropagation(); this.form.reportValidity();
    }
  }, true);
  this.observer = new MutationObserver(() => this.sync());
  this.observer.observe(this.button, {attributes:true,attributeFilter:['disabled','aria-disabled']});
  this.form.querySelector('[name="id"]').addEventListener('change', () => this.sync());
  this.sync();
}
disconnectedCallback() { this.observer?.disconnect(); }
current() {
  const values = Array.from(this.picker.querySelectorAll('select, fieldset'), el =>
    el.tagName === 'SELECT' ? el.value : el.querySelector('input:checked')?.value);
  return this.variants.find(v => v.options.every((val,i) => val === values[i]));
}
setGroup(group, visible) {
  group.hidden = !visible;
  group.querySelectorAll('input,select,textarea').forEach(el => {
    el.disabled = !visible; el.required = visible;
  });
}
valid() { return Array.from(this.querySelectorAll('input,select,textarea')).every(el =>
  el.disabled || (el.checkValidity() && (el.type === 'checkbox' || el.value.trim().length > 0)));
}
sync() {
  const variant = this.current();
  this.setGroup(this.querySelector('[data-child-two]'), !!variant?.option2?.startsWith('2 enfants'));
  this.querySelectorAll('[data-toggle]').forEach(select => {
    const group = this.querySelector('[data-condition="' + select.dataset.toggle + '"]');
    this.setGroup(group, !select.disabled && select.value === (select.dataset.trigger || 'Oui'));
  });
  const stock = this.inventory.find(v => v.id === variant?.id);
  this.querySelector('[data-atelier-stock]').textContent = stock?.tracked && stock.policy !== 'continue'
    ? stock.quantity > 0 ? 'Disponibilité : ' + stock.quantity + (variant.option2.startsWith('2 enfants') ? ' inscriptions famille restantes.' : ' places restantes.') : 'Séance épuisée.'
    : variant?.available ? 'Séance disponible.' : 'Séance indisponible.';
  const disabled = !this.valid() || !variant?.available || this.button.getAttribute('aria-disabled') === 'true';
  if (this.button.disabled !== disabled) this.button.disabled = disabled;
  this.querySelector('[data-form-status]').textContent = !this.valid()
    ? 'Complétez l’inscription pour ajouter au panier.'
    : variant?.available ? 'Inscription complète. Vous pouvez ajouter au panier.' : 'Cette séance est épuisée.';
}
});
}